// src/pages/profile/profile_componnent_edit/EditAgeRange.jsx
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Stack, TextField, Typography, MenuItem } from "@mui/material";
import CustomButton from "../../../Components/CustomButton";

const AGE_RANGES = [
  { value: "moins-18", label: "Moins de 18 ans" },
  { value: "18-24", label: "Jeunes adultes (18 à 24 ans)" },
  { value: "25-34", label: "Adultes (25 à 34 ans)" },
  { value: "35-44", label: "Adultes (35 à 44 ans)" },
  { value: "45-54", label: "Adultes (45 à 54 ans)" },
  { value: "55-64", label: "Seniors actifs (55 à 64 ans)" },
  { value: "65-plus", label: "65 ans et plus" },
];

export default function EditAgeRange({ initialAgeRange, onCancel, onSubmit }) {
  const [ageRange, setAgeRange] = useState(initialAgeRange || "");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAgeRange(initialAgeRange || "");
  }, [initialAgeRange]);

  const handleSave = async () => {
    if (!ageRange) {
      setError(true);
      return;
    }
    setError(false);
    setLoading(true);

    try {
      await onSubmit({ ageRange });
    } catch (e) {
      console.error(e);
    }

    setLoading(false);
  };

  return (
    <Stack spacing={2}>
      <Typography>Tranche d’âge</Typography>

      <TextField
        select
        fullWidth
        label="Sélectionnez votre tranche d’âge"
        value={ageRange}
        onChange={(e) => setAgeRange(e.target.value)}
        error={error && !ageRange}
        helperText={error && !ageRange ? "Veuillez sélectionner une tranche d’âge" : ""}
      >
        {AGE_RANGES.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <CustomButton type="secondaire" buttonText="Annuler" onClick={onCancel} />
        <CustomButton
          loading={loading}
          buttonText="Enregistrer"
          onClick={handleSave}
        />
      </Stack>
    </Stack>
  );
}

EditAgeRange.propTypes = {
  initialAgeRange: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
